












import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';
import { IUserShowObject } from '../../../../shared/types';

import api from '../../api';
import ShowCards from '../../components/ui/show-cards/show-cards.vue';

export default Vue.extend({
  name: 'Movies',

  components: {
    ShowCards,
  },

  data: () => ({
    shows: [] as IUserShowObject[],
  }),

  async created() {
    this.handlePageLoad({
      name: this.$route.name,
    });
    this.requiresLogin();

    this.shows = await api.show.userShows(this.getUser.id, 'movie');
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),
  },

  methods: {
    ...mapActions('navigation', [
      'handlePageLoad',
      'requiresLogin',
    ]),
  },
});
